/** True on the non-editable → editable transition (theme-editor double-click). */
export function enteredEditingMode(
  wasEditable: boolean,
  nowEditable: boolean,
): boolean {
  return nowEditable && !wasEditable;
}
